export default "__VITE_ASSET__C92O3na___"